export const newsList = [
  {
    id: "n1",
    title: "《长夜烬明》开播即登顶，古装权谋再掀追剧热潮",
    summary:
      "由陈望山执导的古装奇幻剧《长夜烬明》开播首周讨论度一路走高，服化道与反转剧情成为观众热议焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20ancient%20Chinese%20palace%20corridor%20lit%20by%20amber%20lanterns%20at%20dusk%2C%20crimson%20and%20gold%20color%20grading%2C%20cinematic%20atmosphere%2C%20soft%20haze%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n1&orientation=landscape",
    category: "开播资讯",
    date: "2026-10-14",
    author: "编辑部",
    content: [
      "《长夜烬明》自开播以来，凭借扎实的剧本与精良的制作迅速登上平台热度榜前列。",
      "剧集以少年将军潜入锦衣司追查家族冤案为主线，将朝堂权谋与奇幻术法巧妙结合。",
      "多位观众表示，第一集的高能反转与考究的服化道，让人一口气追完了已更新的全部剧集。",
    ],
  },
  {
    id: "n2",
    title: "科幻剧《星海拾光》收官，时间悖论结局引全网解析",
    summary:
      "《星海拾光》正式收官，第六集的时间悖论反转成为讨论热点，大量观众在社交平台分享自己的剧情解读。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20view%20from%20a%20space%20station%20window%20toward%20a%20glowing%20amber%20planet%2C%20star%20field%2C%20warm%20orange%20and%20gold%20color%20grading%2C%20sci-fi%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n2&orientation=landscape",
    category: "剧集动态",
    date: "2026-10-09",
    author: "影视观察",
    content: [
      "《星海拾光》以近未来的空间站为舞台，讲述天体物理学家追寻一段神秘信号的故事。",
      "剧组在物理设定上做了大量功课，剧中多次出现的时间校准细节均参考了真实航天资料。",
      "收官后，剧迷们围绕\"信号从何而来\"展开了热烈讨论，多个解析长文获得高赞。",
    ],
  },
  {
    id: "n3",
    title: "悬疑网剧《密室档案》口碑走高，本格推理重回大众视野",
    summary:
      "《密室档案》以\"节目+推理\"的新颖形式获得好评，紧凑节奏与互动式解谜体验让本格推理再次受到关注。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20dim%20library%20room%20with%20old%20case%20files%20scattered%20on%20a%20wooden%20desk%20under%20an%20amber%20lamp%2C%20crimson%20and%20amber%20color%20grading%2C%20mysterious%20mood%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n3&orientation=landscape",
    category: "口碑推荐",
    date: "2026-10-15",
    author: "编辑部",
    content: [
      "《密室档案》将剧本杀式的推理体验搬上屏幕，播出至今口碑持续走高。",
      "每一期的案件都留下了可供观众自行推理的线索，弹幕区俨然成了\"云侦探\"现场。",
      "随着主线谜题逐步揭开，观众对后续发展充满期待。",
    ],
  },
  {
    id: "n4",
    title: "古装动作电影《长安夜行》票房破纪录，动作设计获赞誉",
    summary:
      "《长安夜行》上映后凭借凌厉的动作设计与一夜追凶的紧凑结构收获好评，动作场面被赞\"找回了老武侠的味道\"。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20night%20view%20over%20a%20glowing%20ancient%20Chinese%20capital%20city%20with%20lanterns%20and%20rooftops%2C%20crimson%20and%20amber%20color%20grading%2C%20cinematic%20wide%20shot%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n4&orientation=landscape",
    category: "电影资讯",
    date: "2026-10-12",
    author: "电影前线",
    content: [
      "《长安夜行》以长安一夜连发七案的设定展开，全片节奏紧凑、几乎不留喘息。",
      "动作团队为角色设计的剑术风格兼具观赏性与真实感，多场屋顶长镜头成为亮点。",
      "不少观众表示，片中对古代城市生活的还原让人印象深刻。",
    ],
  },
  {
    id: "n5",
    title: "治愈系网剧《深夜书房》开分 8.6，成年度\"电子布洛芬\"",
    summary:
      "《深夜书房》以安静的单元剧形式讲述书与人之间的治愈故事，开分 8.6，被观众称为\"深夜电子布洛芬\"。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20old%20bookstore%20interior%20at%20night%20with%20tall%20wooden%20shelves%20and%20amber%20lamps%2C%20a%20single%20reading%20chair%2C%20soft%20warm%20brown%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n5&orientation=landscape",
    category: "口碑推荐",
    date: "2026-09-24",
    author: "追剧指南",
    content: [
      "《深夜书房》每集聚焦一位带着烦恼的客人，用一本\"恰好合适\"的书给出温柔的回应。",
      "剧集节奏舒缓、台词隽永，被不少观众列为睡前必看。",
      "有评论认为，它以一种不喧哗的方式，重新定义了治愈剧的表达。",
    ],
  },
  {
    id: "n6",
    title: "电影《无声告白》定档重映，父女情深再掀观影热",
    summary:
      "家庭剧情片《无声告白》宣布将于下月重映，这部讲述父女温情的作品此前曾收获广泛好评。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20dusk%20view%20of%20a%20quiet%20wooden%20pier%20extending%20into%20a%20calm%20sea%20under%20an%20amber%20sky%2C%20soft%20bokeh%2C%20warm%20orange%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n6&orientation=landscape",
    category: "电影资讯",
    date: "2026-10-08",
    author: "电影前线",
    content: [
      "《无声告白》讲述女儿回乡陪伴记忆衰退的父亲、重走一趟旅程的故事。",
      "影片克制而深情的叙事风格获得观众一致认可，结尾的海边长镜头尤为动人。",
      "此次重映将新增幕后花絮片段，为观众带来更完整的观影体验。",
    ],
  },
  {
    id: "n7",
    title: "《浮生微澜》热度攀升，以\"文书博弈\"刷新古装叙事",
    summary:
      "《浮生微澜》凭借女主高智商设定与别出心裁的\"文书博弈\"视角，人气持续走高。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20ancient%20Chinese%20study%20room%20with%20scrolls%20and%20ink%20brushes%20on%20a%20desk%2C%20amber%20candle%20light%2C%20coral%20and%20amber%20color%20grading%2C%20quiet%20elegant%20mood%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n7&orientation=landscape",
    category: "剧集动态",
    date: "2026-10-13",
    author: "追剧指南",
    content: [
      "《浮生微澜》把朝堂博弈的战场放在一封封奏折与密令之间，让权谋戏有了新的表达方式。",
      "女主陆微澜的冷静与机敏获得观众好评，多场文书攻防戏被称\"好看又烧脑\"。",
      "随着旧案线索逐步浮现，剧集热度仍在持续攀升。",
    ],
  },
  {
    id: "n8",
    title: "悬疑剧《沉默的证人》海外发行，律政题材再获关注",
    summary:
      "《沉默的证人》宣布开启海外发行，这部以\"沉默证人\"为切入点的律政悬疑剧将登陆多个平台。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20rainy%20night%20city%20alley%20with%20amber%20streetlight%20reflecting%20on%20wet%20ground%2C%20long%20shadows%2C%20desaturated%20warm%20brown%20and%20crimson%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=800&height=500&seq=cp-news-n8&orientation=landscape",
    category: "行业动态",
    date: "2026-09-30",
    author: "影视观察",
    content: [
      "《沉默的证人》围绕一桩因目击者沉默而扑朔迷离的案件展开，法庭戏张力十足。",
      "剧集在播出期间收获良好口碑，此次海外发行将进一步扩大其影响力。",
      "片方表示，后续还将推出主创访谈等衍生内容。",
    ],
  },
];